module.exports = __webpack_public_path__ + "static/UNITY-Tower-upper-floor-traditional_v2-en-058afaf62cf33ec02d24b999e397970b.pdf";